(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Adds 'Back to top' functionality to an element with the ID 'back-to-top'
 * @example 
 * 1. Create a link-wrapper with ID 'back-to-top'
 * 2. Add an icon inside the link-wrapper such as an arrow
 * 3. Set position fixed: bottom right
 * 4. Set opacity to 0
 */
var BackToTop =
/*#__PURE__*/
function () {
  function BackToTop() {
    _classCallCheck(this, BackToTop);

    this.$backToTop = $('#back-to-top');
    this.toggleDistance = 50;

    if (this.$backToTop.length > 0) {
      this.init();
    }
  }

  _createClass(BackToTop, [{
    key: "init",
    value: function init() {
      var _this = this;

      window.onscroll = function () {
        return _this.scrollFunction();
      };

      this.$backToTop.on('click', function () {
        return _this.scrollToTop();
      });
    }
  }, {
    key: "scrollFunction",
    value: function scrollFunction() {
      if (document.body.scrollTop > this.toggleDistance || document.documentElement.scrollTop > this.toggleDistance) {
        this.$backToTop.css({
          'opacity': '1',
          'cursor': 'pointer',
          'pointer-events': 'all'
        });
      } else {
        this.$backToTop.css({
          // 'opacity': '0',
          'cursor': 'default',
          'pointer-events': 'none'
        });
      }
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  }]);

  return BackToTop;
}();

var _default = BackToTop;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Event handlers for Infinite Scroll
 */
var InfiniteScrollHandler =
/*#__PURE__*/
function () {
  function InfiniteScrollHandler() {
    _classCallCheck(this, InfiniteScrollHandler);

    // Check if exists and initialize
    this.$infScrollWrapper = $('.js-inf-scroll-load');

    if (this.$infScrollWrapper.length > 0) {
      this.init();
    }
  }

  _createClass(InfiniteScrollHandler, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)
      $(document).on('request.infiniteScroll', function () {
        _this.handleInfiteLoad();
      });
      $(document).on('append.infiniteScroll', function () {
        _this.handleInfiniteLoadComplete();
      });
    }
  }, {
    key: "handleInfiteLoad",
    value: function handleInfiteLoad(e) {// find button -> Hide it
      // Make sure GIF spinner is spinning
    }
  }, {
    key: "handleInfiniteLoadComplete",
    value: function handleInfiniteLoadComplete() {// find button -> make visible
    }
  }]);

  return InfiniteScrollHandler;
}();

var _default = InfiniteScrollHandler;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = plugin;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Generate a jQuery plugin
 * @param pluginName [string] Plugin name
 * @param className [object] Class of the plugin
 * @param shortHand [bool] Generate a shorthand as $.pluginName
 *
 * @example
 * import plugin from 'plugin';
 *
 * class MyPlugin {
 *     constructor(element, options) {
 *         // ...
 *     }
 * }
 *
 * MyPlugin.DEFAULTS = {};
 *
 * plugin('myPlugin', MyPlugin');
 */
function plugin(pluginName, className) {
  var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dataName = "__".concat(pluginName);
  var old = $.fn[pluginName];

  $.fn[pluginName] = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data(dataName);
      var options = $.extend({}, className.DEFAULTS, $this.data(), _typeof(option) === 'object' && option);

      if (!data) {
        $this.data(dataName, data = new className(this, options));
      }

      if (typeof option === 'string') {
        data[option]();
      }
    });
  }; // - Short hand


  if (shortHand) {
    $[pluginName] = function (options) {
      return $({})[pluginName](options);
    };
  } // - No conflict


  $.fn[pluginName].noConflict = function () {
    return $.fn[pluginName] = old;
  };
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Script for Responsive Tabs component
 * @example 
 * http://www.entheosweb.com/tutorials/css/tabs.asp
 */
var ResponsiveTabs =
/*#__PURE__*/
function () {
  function ResponsiveTabs(element) {
    _classCallCheck(this, ResponsiveTabs);

    if ($(element).length > 0) {
      // this.init(element);
      var x = window.matchMedia("(min-width: 992px)");

      if (x.matches) {
        this.init(element);
      } else {}
    }
  }

  _createClass(ResponsiveTabs, [{
    key: "init",
    value: function init(element) {
      var _this = this;

      this.$tabsObj = $(element); // Initialize all tab containers and elements to reference

      this.$tabsContainer = this.$tabsObj.find(".tab_container");
      this.$tabs = this.$tabsObj.find('.tabs');
      this.$tabContent = this.$tabsObj.find(".tab_content"); // Hide all tab contents except the first one

      this.$tabsContainer.find('.tab_content').hide();
      this.$tabsContainer.find('.tab_content:first').show();
      this.$drawerToggleIcons = $('.tab_container .oxy-expand-collapse-icon'); // Set the height of the minimum height of the tab container (contains tab contents)
      // to the height of the tabs
      // this.$tabsContainer.css("min-height", () => { 
      //     return this.$tabs.outerHeight() + 50;
      // });

      /* Bind event handler for tabs clicks */

      this.$tabs.find('li').click(function (e) {
        return _this.handleTabClick(e);
      });
      /* Bind event handler for tabs clicks if in drawer mode */

      this.$tabsContainer.find(".tab_drawer_heading").click(function (e) {
        return _this.handleDrawerTabClick(e);
      });
      /* Uncomment to add extra class "tab_last" to last tab */
      //this.$tabs.find('li').last().addClass("tab_last");
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(e) {
      // Hide all tabs contents
      this.$tabContent.hide(); // Get the "rel" value (ID of the contents to display)

      var activeTabID = $(e.currentTarget).attr("rel"); // Fade in the contents for the active tab. Store reference to active tab just in case

      this.$activeTab = this.$tabsContainer.find("#" + activeTabID).fadeIn(); // Remove active class from all tabs

      this.$tabs.find("li").removeClass("active"); //Add active class to tab item that was clicked

      $(e.currentTarget).addClass("active"); // Remove d_active class from drawer heading

      this.$tabsContainer.find(".tab_drawer_heading").removeClass("d_active"); // Add active class to respective drawer heading for the tab that was clicked 

      this.$tabsContainer.find(".tab_drawer_heading[rel^='" + activeTabID + "']").addClass("d_active"); // this.$tabs.css('min-height', 0);
      // // this.$tabsContainer.css("min-height", () => { 
      // //     return this.$tabs.outerHeight() + 50;
      // // });
    }
  }, {
    key: "handleDrawerTabClick",
    value: function handleDrawerTabClick(e) {
      // Hide all tabs contents
      this.$tabContent.hide();
      var $clickTarget = $(e.currentTarget);
      console.log(e); // Remove d_active class from drawer heading

      this.$tabsContainer.find(".tab_drawer_heading").removeClass("d_active"); // Get the "rel" value (ID of the contents to display)

      var d_activeTabID = $(e.currentTarget).attr("rel"); // Fade in the contents for the active tab. Store reference to active tab just in case

      this.$tabsContainer.find("#" + d_activeTabID).fadeIn(); // this.$tabsContainer.find("#"+d_activeTabID).show();
      // Add active class to respective drawer heading for the tab that was clicked 

      $clickTarget.addClass("d_active");
      this.$drawerToggleIcons.addClass('oxy-eci-collapsed');
      $clickTarget.find('.oxy-expand-collapse-icon').removeClass('oxy-eci-collapsed'); // Remove active class from all tabs

      this.$tabs.find("li").removeClass("active"); //Add active class to tab item that was clicked

      this.$tabs.find("li[rel^='" + d_activeTabID + "']").addClass("active"); // this.$tabs.css('min-height', 0);
      // this.$tabs.css("min-height", () => { 
      //     return this.$tabsContainer.outerHeight() + 50;
      // });
    }
  }]);

  return ResponsiveTabs;
}();

var _default = ResponsiveTabs;
exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Opens social sharing links in a small popup window
 * @example 
 * 1. Add the class .js-social-share-popup to social share links
 */
var SocialSharePopups =
/*#__PURE__*/
function () {
  function SocialSharePopups() {
    _classCallCheck(this, SocialSharePopups);

    // Check if exists and initialize
    this.$socialShareLinks = $('.js-social-share-popup');
    this.viewportMinSize = 768;

    if (this.$socialShareLinks.length > 0 && $(window).width() > this.viewportMinSize) {
      this.init();
    }
  }

  _createClass(SocialSharePopups, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)
      console.log('social popups initialized');
      this.$socialShareLinks.on('click', function (e) {
        return _this.handleSocialShareLinkClick(e);
      });
    }
  }, {
    key: "handleSocialShareLinkClick",
    value: function handleSocialShareLinkClick(e) {
      e.preventDefault();
      var targetUrl = $(e.currentTarget).attr('href');
      var newWin = window.open(targetUrl, 'sharewindow', 'width=600,height=400');
    }
  }]);

  return SocialSharePopups;
}();

var _default = SocialSharePopups;
exports.default = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var Typewriter =
/*#__PURE__*/
function () {
  function Typewriter() {
    _classCallCheck(this, Typewriter);

    // Check if exists and initialize
    this.$typed = $('.js-auto-input');

    if (this.$typed.length > 0) {
      this.init();
    }
  }

  _createClass(Typewriter, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      var typed = new Typed(".js-auto-input", {
        strings: ["Attract", "Retain", "Engage", "Appreciate"],
        typeSpeed: 100,
        backSpeed: 100,
        loop: true
      });
    }
  }]);

  return Typewriter;
}();

var _default = Typewriter;
exports.default = _default;

},{}],7:[function(require,module,exports){
"use strict";

var _jqueryPlugin = _interopRequireDefault(require("./modules/jquery-plugin"));

var _backToTop = _interopRequireDefault(require("./modules/back-to-top"));

var _socialSharePopups = _interopRequireDefault(require("./modules/social-share-popups"));

var _infiniteScrollHandlers = _interopRequireDefault(require("./modules/infinite-scroll-handlers"));

var _responsiveTabs = _interopRequireDefault(require("./modules/responsive-tabs"));

var _typewriter = _interopRequireDefault(require("./modules/typewriter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
window.$ = jQuery;
$(document).ready(function () {
  $('html').addClass('js-on-load');
  var backToTop = new _backToTop.default();
  var socialSharePopups = new _socialSharePopups.default();
  var infiniteScrollHandler = new _infiniteScrollHandlers.default();
  var typewriter = new _typewriter.default();
  (0, _jqueryPlugin.default)('ResponsiveTabs', _responsiveTabs.default);
  var $responsiveTabs = $('.responsive-tabs-component');

  if ($responsiveTabs.length > 0) {
    $responsiveTabs.ResponsiveTabs();
  }
});

},{"./modules/back-to-top":1,"./modules/infinite-scroll-handlers":2,"./modules/jquery-plugin":3,"./modules/responsive-tabs":4,"./modules/social-share-popups":5,"./modules/typewriter":6}]},{},[7]);
